import type { Size } from '../types'

export function WbIncandescentIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2492_55028"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          width="16"
          height="16"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2492_55028)">
        <path
          d="M7.5 14.4998V12.5895H8.5V14.4998H7.5ZM1.5 8.4998V7.4998H3.41033V8.4998H1.5ZM12.5897 8.4998V7.4998H14.5V8.4998H12.5897ZM12.0128 13.0485L10.677 11.7126L11.3795 11.0101L12.7153 12.346L12.0128 13.0485ZM3.98717 13.0485L3.28467 12.346L4.6205 11.0101L5.323 11.7126L3.98717 13.0485ZM8 10.9998C7.16756 10.9998 6.45944 10.7079 5.87567 10.1241C5.29189 9.54035 5 8.83224 5 7.9998C5 7.49213 5.11944 7.02163 5.35833 6.5883C5.59722 6.15496 5.92222 5.79641 6.33333 5.51263V2.56396H9.66667V5.51263C10.0778 5.79641 10.4028 6.15496 10.6417 6.5883C10.8806 7.02163 11 7.49213 11 7.9998C11 8.83224 10.7081 9.54035 10.1243 10.1241C9.54056 10.7079 8.83244 10.9998 8 10.9998ZM7.33333 5.0793C7.44444 5.05285 7.5545 5.03297 7.6635 5.01963C7.7725 5.00641 7.88467 4.9998 8 4.9998C8.11533 4.9998 8.2275 5.00641 8.3365 5.01963C8.4455 5.03297 8.55556 5.05285 8.66667 5.0793V3.56396H7.33333V5.0793ZM8 9.9998C8.55556 9.9998 9.02778 9.80535 9.41667 9.41646C9.80556 9.02758 10 8.55535 10 7.9998C10 7.44424 9.80556 6.97202 9.41667 6.58313C9.02778 6.19424 8.55556 5.9998 8 5.9998C7.44444 5.9998 6.97222 6.19424 6.58333 6.58313C6.19444 6.97202 6 7.44424 6 7.9998C6 8.55535 6.19444 9.02758 6.58333 9.41646C6.97222 9.80535 7.44444 9.9998 8 9.9998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
